const FIREBASE_CONST = {
  USER_NOT_FOUND: 'auth/user-not-found',
  EMAIL_ALREADY_EXISTS: 'auth/email-already-in-use',
  WRONG_PASSWORD: 'auth/invalid-credential',
  FILE_NOT_FOUND: 'storage/object-not-found',
  TOO_MANY_REQUESTS: 'auth/too-many-requests',
}

export default FIREBASE_CONST
